var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "50%" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { "min-width": "500px" } },
        [
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2 pa-0",
                  attrs: { icon: "", color: "red" },
                  on: { click: _vm.onClose },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0", attrs: { dense: "" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "mx-3 mb-3",
                  staticStyle: { "overflow-y": "scroll" },
                  attrs: {
                    width: "100%",
                    height: "400px",
                    elevation: "0",
                    outlined: "",
                  },
                },
                [
                  _c(
                    "v-card-actions",
                    [
                      _vm.working
                        ? _c("v-progress-linear", {
                            attrs: {
                              color: "red",
                              indeterminate: "",
                              rounded: "",
                              height: "6",
                            },
                          })
                        : _vm._e(),
                      _vm.jsonData != null
                        ? _c("json-viewer", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              value: _vm.jsonData,
                              "expand-depth": 10,
                              copyable: "",
                            },
                          })
                        : _vm._e(),
                      _vm.imageData != null
                        ? _c("v-img", {
                            attrs: {
                              src: _vm.imageData,
                              width: "100%",
                              contain: "",
                              height: "350px",
                            },
                          })
                        : _vm._e(),
                      _vm.xmlData
                        ? _c("code-highlight", { attrs: { language: "xml" } }, [
                            _vm._v(" " + _vm._s(_vm.xmlData) + " "),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }